import { JsonNgforPipe } from './pipes/json-ngfor.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Ng5SliderModule } from 'ng5-slider';
import { HttpClientModule } from '@angular/common/http';
import { GoogleChartsModule } from 'angular-google-charts';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxSpinnerModule } from 'ngx-spinner';
import { JwtModule } from '@auth0/angular-jwt';

import { AppComponent } from './app.component';
import { MapComponent } from './components/map/map.component';

import { PolygonService } from './services/polygon.service';

import { NgSelectModule } from '@ng-select/ng-select';

import { AppRoutingModule } from './app-routing.module';


import { CovidHospitalsService } from './services/covidHospitals.service';
import { CovidMedicalConsultantsService } from './services/covidMedicalConsultants.service';
import { CovidPharmacyService } from './services/covidPharmacy.service';
import { CovidDoctor } from './services/covidDoctor.service';
import { CovidLabsService } from './services/covidLabs.service';
import { AuthService } from './services/auth.service';

import { RadialMenuComponent } from './components/radial-menu/radial-menu.component';
import { LandingComponent } from './components/landing/landing.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { DataTablesModule } from 'angular-datatables';
import { LoginComponent } from './components/login/login.component';

@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    RadialMenuComponent,
    JsonNgforPipe,
    LandingComponent,
    NotFoundComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule,
    Ng5SliderModule,
    HttpClientModule,
    GoogleChartsModule.forRoot(),
    FormsModule,
    NgbModule,
    DragDropModule,
    NgSelectModule,
    AppRoutingModule,
    NgxSpinnerModule,
    DataTablesModule,
    JwtModule.forRoot({
      config: {
        /* tokenGetter: tokenGetter */
      }
    })
  ],
  providers: [
    PolygonService,
    CovidHospitalsService,
    CovidMedicalConsultantsService,
    CovidPharmacyService,
    CovidDoctor,
    CovidLabsService,
    AuthService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
